import { chain, invert, startCase } from 'lodash';
import TopStatuses from '../../Constants/top-statuses';
import TopStatusVendorDisplay from '../../Constants/top-status-vendor-display';

function getStatuses(order) {
  const topItems = order.purchase_order_lines.filter(
    (item) => item.quantity > 0,
  );
  return topItems.map(
    (item) => TopStatusVendorDisplay[invert(TopStatuses)[item.top_status]],
  );
}

function getNullStatuses(order) {
  return order.purchase_order_lines.filter(
    (item) => item.top_status === null && item.quantity > 0,
  );
}

export function isOrderSelectable(order) {
  return makeTopStatuses(order, false)[0] === TopStatusVendorDisplay.APPROVED;
}

export default function makeTopStatuses(order, superuser) {
  const topItems = chain(order)
    .get('purchase_order_lines')
    .filter((item) => item.quantity > 0)
    .value();

  const topStatuses = chain(topItems)
    .map((item) =>
      item.top_status ? `${startCase(item.top_status)} - ${item.size}` : null,
    )
    .compact()
    .uniq()
    .value();

  if (superuser) {
    return topStatuses.length < 1 || !topStatuses ? ['Approved'] : topStatuses;
  }

  const topStatusesWithoutFmt = getStatuses(order);

  const nullStatuses = getNullStatuses(order);
  // If all items have a null top status, then the status should be APPROVED
  if (nullStatuses.length >= topStatusesWithoutFmt.length) {
    return [TopStatusVendorDisplay.APPROVED];
  }

  // If one of the items is Rejected or Pending Receipt or Received, then the status should be one of those
  if (topStatusesWithoutFmt.includes(TopStatusVendorDisplay.REJECTED)) {
    return [TopStatusVendorDisplay.REJECTED];
  }
  if (topStatusesWithoutFmt.includes(TopStatusVendorDisplay.PENDING_RECEIPT)) {
    return [TopStatusVendorDisplay.PENDING_RECEIPT];
  }
  if (topStatusesWithoutFmt.includes(TopStatusVendorDisplay.RECEIVED)) {
    return [TopStatusVendorDisplay.RECEIVED];
  }

  return [TopStatusVendorDisplay.APPROVED];
}
